/**
 * Invite verify journey accents — aligned with Add Invite (`button` / `primary` in tailwind.config.js).
 * Send Invitation: bg #1597ff, hover #0d7acc; headings/links: primary #2e437a.
 */

export const invitePrimaryButtonClass =
  'inline-flex items-center justify-center rounded-xl bg-button px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-button-hover disabled:cursor-not-allowed disabled:opacity-60'

export const inviteSubmitButtonClass =
  'flex w-full max-w-md items-center justify-center rounded-md bg-button px-6 py-3 text-base font-bold text-white transition hover:bg-button-hover disabled:cursor-not-allowed disabled:opacity-50'

export const invitePrimaryButtonCompactClass =
  'inline-flex items-center justify-center rounded-xl bg-button px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-button-hover disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500'

export const inviteSecondaryButtonClass =
  'rounded-xl border border-primary/25 bg-white px-5 py-2.5 text-sm font-semibold text-primary transition hover:bg-sky-50 disabled:opacity-60'

export const inviteSectionIconClass = 'h-4 w-4 text-button'

export const inviteCheckboxClass =
  'mt-1 h-4 w-4 rounded border-slate-300 text-button focus:ring-button'

export const inviteAckRowHoverClass = 'hover:border-sky-200'

export const inviteStepActiveClass = 'bg-slate-400 text-white ring-4 ring-slate-100'

export const inviteStepConnectorActiveClass = 'bg-slate-300'

export const inviteStepLabelActiveClass = 'text-slate-600'

export const inviteFormHeadingClass = 'text-sm font-semibold text-primary'

export const inviteFormLinkClass = 'font-medium text-primary hover:text-button'

export const inviteInputFocusClass =
  'focus:border-button focus:outline-none focus:ring-2 focus:ring-sky-100'

export const inviteAckContentClass =
  'text-sm leading-relaxed text-slate-700 [&_b]:font-bold [&_strong]:font-bold [&_h1]:mb-2 [&_h1]:text-lg [&_h1]:font-bold [&_h1]:text-slate-900 [&_h2]:mb-2 [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-slate-900 [&_h3]:mb-2 [&_h3]:text-base [&_h3]:font-bold [&_h3]:text-slate-900 [&_h4]:font-bold [&_h5]:font-bold [&_h6]:font-bold [&_li]:ml-5 [&_li]:list-disc [&_p]:mb-3 [&_ul]:mb-3'

/** Welcome step — left-aligned body copy (matches mobile). */
export const inviteWelcomeContentClass = inviteAckContentClass
